import { render, staticRenderFns } from "./ActionForm.vue?vue&type=template&id=e831a74a"
import script from "./ActionForm.vue?vue&type=script&lang=ts"
export * from "./ActionForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports